import { Component, OnInit, inject } from '@angular/core';
import { FormNavigationService } from '../../../../services/form-navigation/form-navigation.service';
import { NavigationKey } from '../../../../enums/navigation-key-type';

@Component({
  selector: 'app-potential-technical-defect-redirect',
  template: '<div>Redirecting...</div>',
  standalone: true
})
export class PotentialTechnicalDefectRedirectComponent implements OnInit {
  private formNavigationService = inject(FormNavigationService);

  ngOnInit() {
    // Immediately redirect to the appropriate next step
    this.formNavigationService.navigate(NavigationKey['potential-technical-defect']);
  }
}